/**
 * External dependencies
 */
import { registerPlugin } from '@wordpress/plugins';

const render = () => {};

registerPlugin( 'woocommerce-checkout-field-editor-pro', {
	render,
	scope: 'woocommerce-checkout',
} );